import React from 'react';

import Downarrow from '../assets/img/downarrow.svg';

const Milestone = () => {
    return (
        <section className="milestone-sec">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="milestone_header text-center">
                            <h6 className="small-heading" data-aos="fade-up">Milestone year by year</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">Progress to date</h3>
                        </div>
                        <div className="milestone_body text-center">
                            <div className="row">
                                <div className="col-lg-6 offset-lg-3">
                                    <div className="milestone_box" data-aos="fade-up" data-aos-duration={1000}>
                                        <p>Granted the first and only mobile X-ray license to operate the service to nursing home residents in Ireland. The first-ever bedside X-ray in an Irish nursing home was taken.</p>
                                        <hr />
                                        <span className="heading-gradient">2018, June</span>
                                    </div>
                                    <div className="milestone_box" data-aos="fade-up" data-aos-duration={2000}>
                                        <p>Granted the first and only mobile X-ray license to operate the service to nursing home residents in Ireland. The first-ever bedside X-ray in an Irish nursing home was taken.</p>
                                        <hr />
                                        <span className="heading-gradient">2018, November</span>
                                    </div>
                                    <img src={Downarrow} data-aos="fade-up" data-aos-duration={2500} />
                                    <div className="milestone_box" data-aos="fade-up" data-aos-duration={3000}>
                                        <p>Granted the first and only mobile X-ray license to operate the service to nursing home residents in Ireland. The first-ever bedside X-ray in an Irish nursing home was taken.</p>
                                        <hr />
                                        <span className="heading-gradient">2019</span>
                                    </div>
                                    <img src={Downarrow} data-aos="fade-up" data-aos-duration={3500} />
                                    <div className="milestone_box" data-aos="fade-up" data-aos-duration={4000}>
                                        <p>Granted the first and only mobile X-ray license to operate the service to nursing home residents in Ireland. The first-ever bedside X-ray in an Irish nursing home was taken.</p>
                                        <hr />
                                        <span className="heading-gradient">2020</span>
                                    </div>
                                    <img src={Downarrow} data-aos="fade-up" data-aos-duration={4500} />
                                    <div className="milestone_box" data-aos="fade-up" data-aos-duration={5000}>
                                        <p>Granted the first and only mobile X-ray license to operate the service to nursing home residents in Ireland. The first-ever bedside X-ray in an Irish nursing home was taken.</p>
                                        <hr />
                                        <span className="heading-gradient">2021</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Milestone;